export const SET_NOTA_BIMESTRE = 'SET_NOTA_BIMESTRE'
export const SET_NOTAS_BIMESTRE = 'SET_NOTAS_BIMESTRE'
export const UPDATE_NOTAS_BIMESTRE = 'UPDATE_NOTAS_BIMESTRE'
export const REMOVE_NOTAS_BIMESTRE = 'REMOVE_NOTAS_BIMESTRE'

